/**
 * RequestsList Component (Sponsor View)
 *
 * Simplified list display for a sponsor's own advisory requests
 */

import React from 'react';

import { Box } from '@mui/material';

import RequestCard from './RequestCard'; // Simplified RequestCard for sponsor view
import * as S from '../../LeadRequestOrchestration/components/styles';
import Spin from 'components/Spin';
import Text from 'components/Text';
import { LeadRequest } from 'types/leadRequestsTypes';

interface RequestsListProps {
  requests: LeadRequest[];
  loading: boolean;
  error: string | null;
  onViewDetails: (request: LeadRequest) => void;
  onCancelRequest: (request: LeadRequest) => void;
  cancelingId: string | null;
}

const RequestsList: React.FC<RequestsListProps> = ({
  requests,
  loading,
  error,
  onViewDetails,
  onCancelRequest,
  cancelingId,
}) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <Spin />
      </Box>
    );
  }

  if (error) {
    return (
      <S.EmptyState>
        <Text size="large" color="red" bold>
          Erro ao carregar solicitações
        </Text>
        <Text size="medium" color="textSecondary">
          {error}
        </Text>
      </S.EmptyState>
    );
  }

  if (requests.length === 0) {
    return (
      <S.EmptyState>
        <S.EmptyIcon>📋</S.EmptyIcon>
        <Text size="large" bold>
          Nenhuma solicitação de lead encontrada
        </Text>
        <Text size="medium" color="textSecondary">
          Crie uma nova solicitação para começar.
        </Text>
      </S.EmptyState>
    );
  }

  return (
    <S.RequestsListContainer>
      {requests.map(request => (
        <RequestCard
          key={request.id}
          request={request}
          onViewDetails={onViewDetails}
          onCancel={() => onCancelRequest(request)}
          isCanceling={cancelingId === request.id}
        />
      ))}
    </S.RequestsListContainer>
  );
};

export default RequestsList;
